import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';

import { CommonModule } from '@angular/common';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { KeyboardEffects } from './+state/keyboard.effects';
import { KEYBOARD_FEATURE_KEY, reducer } from './+state/keyboard.reducer';
import { KeyboardShortcutsListenerComponent } from './components/keyboard-shortcuts-listener.component';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(KEYBOARD_FEATURE_KEY, reducer),
    EffectsModule.forFeature([KeyboardEffects]),
    KeyboardShortcutsModule.forRoot(),
  ],
  declarations: [KeyboardShortcutsListenerComponent],
  exports: [KeyboardShortcutsListenerComponent],
})
export class AppKeyboardModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: AppKeyboardModule
  ) {
    if (parentModule) {
      throw new Error(
        'AppKeyboardModule is already loaded. Import only in AppModule'
      );
    }
  }

  static forRoot(): ModuleWithProviders<AppKeyboardModule> {
    return {
      ngModule: AppKeyboardModule,
      providers: [],
    };
  }
}
